// Enhancement only: every product property and Shopify cart form works without this file.
document.addEventListener('change', (event) => {
  const input = event.target;
  if (!(input instanceof HTMLInputElement) || !input.checked) return;
  if (input.dataset.shmoFront) {
    const preview = input.closest('[data-shmo-design-picker]')?.querySelector('[data-shmo-front-preview]');
    if (preview instanceof HTMLImageElement) {
      preview.src = input.dataset.shmoFront;
      preview.alt = input.value;
    }
  }
  if (input.dataset.shmoPlaque) {
    const preview = input.closest('.product-information')?.querySelector('[data-shmo-main-art]');
    if (preview instanceof HTMLImageElement) {
      preview.src = input.dataset.shmoPlaque;
      preview.alt = input.value + ', ' + input.closest('fieldset').querySelector('legend').textContent;
    }
  }
});

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  const menu = event.target.closest('.shmo-shop-mobile-menu');
  if (menu && event.target.closest('a')) menu.removeAttribute('open');
  if (!menu) document.querySelectorAll('.shmo-shop-mobile-menu[open]').forEach((openMenu) => openMenu.removeAttribute('open'));
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.shmo-shop-mobile-menu[open]').forEach((menu) => {
    menu.removeAttribute('open');
    menu.querySelector('summary')?.focus();
  });
});

const header = document.querySelector('.shmo-shop-header');
if (header && 'ResizeObserver' in window) {
  new ResizeObserver(([entry]) => {
    document.documentElement.style.setProperty('--shmo-header-height', `${entry.target.getBoundingClientRect().height}px`);
  }).observe(header);
}
